import {
  ArrowLeft,
  ArrowRight,
  Bold,
  Briefcase,
  Check,
  ChevronDown,
  Copy,
  Download,
  FilePenLine,
  FileText,
  House,
  ImagePlus,
  Maximize2,
  Minimize2,
  LoaderCircle,
  Minus,
  Mic2,
  Newspaper,
  PanelsTopLeft,
  Play,
  Plus,
  Podcast,
  RectangleHorizontal,
  RotateCw,
  RotateCcw,
  SlidersHorizontal,
  Smartphone,
  Square,
  Upload,
  Video,
  WandSparkles,
  X,
  createIcons,
} from 'lucide';

export function initIcons() {
  createIcons({
    icons: {
      ArrowLeft,
      ArrowRight,
      Bold,
      Briefcase,
      Check,
      ChevronDown,
      Copy,
      Download,
      FilePenLine,
      FileText,
      House,
      ImagePlus,
      Maximize2,
      Minimize2,
      LoaderCircle,
      Minus,
      Mic2,
      Newspaper,
      PanelsTopLeft,
      Play,
      Plus,
      Podcast,
      RectangleHorizontal,
      RotateCw,
      RotateCcw,
      SlidersHorizontal,
      Smartphone,
      Square,
      Upload,
      Video,
      WandSparkles,
      X,
    },
  });
}
